// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.gender__radio-wrapper[data-v-7fd7316f] {\n  margin: 20px -15px 0;\n}\n.gender__radio[data-v-7fd7316f] {\n  margin: 0 15px;\n}\n.gender__radio--disabled[data-v-7fd7316f],\n.gender__processing--disabled[data-v-7fd7316f] {\n  pointer-events: none;\n}\n.gender__processing[data-v-7fd7316f] {\n  margin-top: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
